export default __webpack_public_path__ + "static/media/hotdog.64940fba.webp";